import React, { useEffect, useState } from "react";



function UsersModal({ show, onClose }) {

    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [confirmingUserId, setConfirmingUserId] = useState(null);
    const [confirmText, setConfirmText] = useState("");
    const [deleteError, setDeleteError] = useState("");

    const getRoleName = (role) => {
        switch (Number(role)) {
            case 1:
                return "Admin";
            case 2:
                return "Doctor";
            case 3:
                return "Staff";
            default:
                return `Role ${role}`;
        }
    };


    useEffect(() => {
        if (show) {
            fetchUsers();
        }
    }, [show]);

    const fetchUsers = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");

            const res = await fetch("/v1/clinic/users", {
                headers: {
                    Authorization: "Bearer " + token
                }
            });

            const data = await res.json();
            setUsers(data);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteUser = async (id) => {
        try {
            setDeleteError(""); // reset old error
            const token = localStorage.getItem("token");

            const res = await fetch(`/v1/clinic/users/${id}`, {
                method: "DELETE",
                headers: {
                    Authorization: "Bearer " + token
                }
            });

            if (res.ok) {
                setUsers(users.filter(u => u.id !== id));
                setConfirmingUserId(null);
                setConfirmText("");
            } else {
                // 🔥 capture backend message
                const msg = await res.text();
                setDeleteError(msg || "Delete failed");
            }

        } catch (err) {
            console.error(err);
            setDeleteError("Something went wrong");
        }
    };

    if (!show) return null;

    return (
        <>
            <div className="modal-backdrop fade show"></div>

            <div className="modal show fade d-block" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title">Clinic Users</h5>
                            <button className="btn-close" onClick={onClose}></button>
                        </div>

                        <div className="modal-body">

                            {users.length === 0 ? (
                                <p>No users found</p>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-bordered table-sm">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Username</th>
                                                <th>Role</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {users.map((u) => (
                                                <tr key={u.id}>
                                                    <td>{u.username}</td>
                                                    <td>{getRoleName(u.role)}</td>
                                                    <td>
                                                        {confirmingUserId === u.id ? (
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm mb-1"
                                                                    placeholder={`Type "${u.username}" to confirm`}
                                                                    value={confirmText}
                                                                    onChange={(e) => setConfirmText(e.target.value)}
                                                                />

                                                                <small className="text-danger d-block mb-1">
                                                                    This action cannot be undone
                                                                </small>

                                                                {deleteError && (
                                                                    <small className="text-danger d-block">
                                                                        {deleteError}
                                                                    </small>
                                                                )}

                                                                <div className="d-flex gap-1">
                                                                    <button
                                                                        className="btn btn-danger btn-sm"
                                                                        disabled={confirmText.toLowerCase() !== u.username.toLowerCase()}
                                                                        onClick={() => handleDeleteUser(u.id)}
                                                                    >
                                                                        Confirm
                                                                    </button>

                                                                    <button
                                                                        className="btn btn-secondary btn-sm"
                                                                        onClick={() => {
                                                                            setConfirmingUserId(null);
                                                                            setConfirmText("");
                                                                        }}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <button
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => {
                                                                    setConfirmingUserId(u.id);
                                                                    setConfirmText("");
                                                                }}
                                                            >
                                                                Delete
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>

                                    </table>
                                </div>
                            )}

                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={onClose}>
                                Close
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default UsersModal;
